/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SpoDetailComponent} from './spo-detail-display/spo-detail.component';
import {PipesModule} from '../pipes/pipes.module';
import {SpoDetailFormComponent} from './spo-detail-form/spo-detail-form.component';
import {ReactiveFormsModule} from '@angular/forms';
import {NgbDatepickerModule, NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap';
import {WarningsModule} from '../warnings/warnings.module';
import {LoadingSpinnerModule} from '../loading/loading-spinner/loading-spinner.module';
import {TooltipModule} from '../tooltip/tooltip.module';
import {InputModule} from '../input/input.module';

@NgModule({
    declarations: [SpoDetailComponent, SpoDetailFormComponent],
    imports: [
        CommonModule,
        PipesModule,
        ReactiveFormsModule,
        NgbTypeaheadModule,
        NgbDatepickerModule,
        WarningsModule,
        LoadingSpinnerModule,
        TooltipModule,
        InputModule
    ],
    exports: [SpoDetailComponent, SpoDetailFormComponent]
})
export class SpoDetailModule {
}
